// i18n.js
export const i18n = {
  t: {}, // Will be made reactive by Alpine.store
  currentLang: "",
  loading: false,

  async init() {
    // Watch for language changes in your user preferences
    Alpine.effect(async () => {
      const lang = Alpine.store("userPreferences").uiLanguage;
      if (lang !== this.currentLang) {
        await this.loadLanguage(lang);
      }
    });
  },

  async loadLanguage(lang) {
    this.loading = true;
    try {
      // Dynamic import: Only the required language file is downloaded
      const response = await fetch(`/res/i18n/${lang}.json`);
      if (!response.ok) throw new Error("Language file not found");
      this.t = await response.json();
      this.currentLang = lang;
    } catch (e) {
      console.error(`Could not load language: ${lang}`, e);
      this.loading = false;
    } finally {
      this.loading = false;
    }
  },
};
